import { asyncRouterMap, constantRouterMap } from '@/router/index'

const asyncRouters = {
    state: {
        routers: constantRouterMap,
        addRouters: [],
        asyncRouterEnd:false
    },
    mutations: {
        SET_ROUTERS: (state, routers) => {
            state.addRouters = routers?routers:state.addRouters
            state.routers = constantRouterMap.concat(routers)
            state.asyncRouterEnd = true
        }
    },
    actions: {
        GenerateRoutes({ commit }, userno) {
            return new Promise(resolve => {
                commit('SET_ROUTERS', asyncRouterMap[userno])
                resolve()
            })
        }
    }
}

export default asyncRouters
